const actionsTypes = {
    SET_DATA_AUDIOGUIDE: "SET_DATA_AUDIOGUIDE",
    SET_AVARAGE_RATE: "SET_AVARAGE_RATE",
    SET_ORIGIN_ROUTE: "SET_ORIGIN_ROUTE",
    SET_LANG: "SET_LANG",
    SET_DISPLAY_MENU: "SET_DISPLAY_MENU",
    SET_DISPLAY_CONTENT: "SET_DISPLAY_CONTENT"
}

export { actionsTypes }